var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 369.748 369.748",
    style: {
      enableBackground: "new 0 0 369.748 369.748"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.646,130.413h10.773l30.328-59.871l-23.332-27.688h-16.813V22.696h11.988c2.127,0,3.852-1.727,3.852-3.854  c0-2.127-1.725-3.852-3.852-3.852h-30.497c-2.128,0-3.853,1.725-3.853,3.852c0,2.127,1.725,3.854,3.853,3.854h11.988v20.158h-72.172  l-23.333,27.688l30.328,59.871h10.773v64.029h-97.016v-32.5H36.334v32.5H0v160.314h45.664v-79.982h57.666v79.982H360V194.442  h-31.354V130.413z M267.974,115.249l-14.521-29.543h28.15v29.543H267.974z M107.33,241.108H29.996v-23.332h77.334V241.108z   M199.33,241.108h-77.334v-23.332h77.334V241.108z M291.33,241.108h-77.334v-23.332h77.334V241.108z M309.404,115.249h-21.482  V85.706h21.482V115.249z M315.723,85.706h28.152l-14.522,29.543h-13.631V85.706z",
    fill: "#FFFFFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.723b13b4c072598dd65a80d39551b22b.svg";
export { ForwardRef as ReactComponent };